import { render, staticRenderFns } from "./CouponDetails.vue?vue&type=template&id=1bf76d82&scoped=true"
import script from "./CouponDetails.vue?vue&type=script&lang=js"
export * from "./CouponDetails.vue?vue&type=script&lang=js"
import style0 from "./CouponDetails.vue?vue&type=style&index=0&id=1bf76d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf76d82",
  null
  
)

export default component.exports